import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { useGet } from "@/lib/api";
import { BookOpen } from "lucide-react";

function Block({ title, what, why }) {
  return (
    <div className="glass rounded-2xl p-3.5">
      <div className="font-semibold text-sm">{title}</div>
      {what && <p className="text-xs text-[#9CA3AF] mt-1 leading-relaxed">{what}</p>}
      {why && <p className="text-xs text-[#D1D5DB] mt-1.5 leading-relaxed"><span className="text-[#F59E0B] font-semibold">Gold: </span>{why}</p>}
    </div>
  );
}

export function GlossaryDialog({ trigger }) {
  const { data } = useGet("/glossary");
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent data-testid="glossary-dialog" className="bg-[#0A0D14] border-white/10 text-[#F9FAFB] max-w-lg w-[calc(100vw-1.5rem)] sm:w-full max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2"><BookOpen size={20} className="text-[#F59E0B]" /> Plain-English Guide</DialogTitle>
          <DialogDescription className="text-sm text-[#9CA3AF] text-left">What every number in this app means and why it moves gold.</DialogDescription>
        </DialogHeader>
        {!data ? <div className="text-sm text-[#6B7280]">Loading…</div> : (
          <div className="space-y-5">
            <section>
              <h3 className="text-[11px] uppercase tracking-wider text-[#6B7280] font-mono-num mb-2">Key terms</h3>
              <div className="grid gap-2">{data.terms.map((t) => <Block key={t.term} title={t.term} what={t.meaning} />)}</div>
            </section>
            <section>
              <h3 className="text-[11px] uppercase tracking-wider text-[#6B7280] font-mono-num mb-2">Market drivers</h3>
              <div className="grid gap-2">{data.drivers.map((d) => <Block key={d.code} title={d.title} what={d.what} why={d.why_gold} />)}</div>
            </section>
            <section>
              <h3 className="text-[11px] uppercase tracking-wider text-[#6B7280] font-mono-num mb-2">Economic indicators</h3>
              <div className="grid gap-2">{data.indicators.map((i) => <Block key={i.code} title={i.title} what={i.what} why={i.why_gold} />)}</div>
            </section>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
